export const APP_STORE_APP_PAGE_LINK = 'https://apps.apple.com/by/app/fluffy-dog-training-health/id1567796848';
export const PLAY_MARKET_APP_PAGE_LINK = 'https://play.google.com/store/apps/details?id=com.strelka.app';
